import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from '../navigation/Sidebar';
import { useAuth } from '../../../features/auth/contexts/AuthContext';
import { LogOut, User, ChevronLeft, ChevronRight } from 'lucide-react';

export function MainLayout() {
  const { user, signOut } = useAuth();
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Don't render MainLayout for project pages
  const projectMatch = location.pathname.match(/^\/projects\/([^\/]+)/);
  const isProjectPage = !!projectMatch;
  
  console.log('MainLayout - Current path:', location.pathname);
  console.log('MainLayout - Is project page:', isProjectPage);
  console.log('MainLayout - Project match:', projectMatch);
  
  if (isProjectPage) {
    console.log('MainLayout - Rendering Outlet only (no sidebar)');
    return <Outlet />;
  }

  console.log('MainLayout - Rendering full layout with sidebar');

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <div className="h-screen flex bg-gray-50">
      {/* Sidebar - Only for non-project pages */}
      <div className={`${sidebarCollapsed ? 'w-16' : 'w-72'} bg-white border-r border-gray-200 transition-all duration-300 flex flex-col`}>
        <Sidebar 
          collapsed={sidebarCollapsed} 
          useTabNavigation={false} 
        />
        
        {/* Spacer to push user section to bottom */}
        <div className="mt-auto" />
        
        {/* User section at bottom */}
        <div className="border-t border-gray-200">
          <div className="p-4 lg:p-5 xl:p-6">
            <div className={`flex items-center ${sidebarCollapsed ? 'justify-center' : 'justify-between'}`}>
              <div className={`flex items-center gap-3 ${sidebarCollapsed ? 'hidden' : ''}`}>
                <div className="w-8 h-8 lg:w-10 lg:h-10 xl:w-10 xl:h-10 bg-gray-100 rounded-full flex items-center justify-center">
                  <User className="h-4 w-4 lg:h-5 lg:w-5 xl:h-5 xl:w-5 text-gray-600" />
                </div>
                <div className="overflow-hidden">
                  <p className="text-sm lg:text-base xl:text-base font-medium text-gray-900 truncate">{user?.email}</p>
                </div>
              </div>
              {sidebarCollapsed && (
                <User className="h-5 w-5 lg:h-6 lg:w-6 xl:h-6 xl:w-6 text-gray-600 mx-auto" />
              )}
            </div>
            
            <button
              onClick={handleSignOut}
              className={`mt-3 w-full flex items-center justify-center gap-2 px-3 lg:px-4 xl:px-4 py-2 lg:py-2.5 xl:py-2.5 text-sm lg:text-base xl:text-base text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors ${sidebarCollapsed ? 'px-2' : ''}`}
            >
              <LogOut className="h-4 w-4 lg:h-5 lg:w-5 xl:h-5 xl:w-5" />
              {!sidebarCollapsed && <span>Sign out</span>}
            </button>
          </div>
        </div>
        
        {/* Collapse toggle */}
        <button
          onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          className="absolute -right-3 top-8 w-6 h-6 bg-white border border-gray-200 rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors"
        >
          {sidebarCollapsed ? (
            <ChevronRight className="h-3 w-3 text-gray-600" />
          ) : (
            <ChevronLeft className="h-3 w-3 text-gray-600" />
          )}
        </button>
      </div>

      {/* Main content area */}
      <div className="flex-1 flex flex-col">
        {/* Page content */}
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}